import { EmployeeListContainer } from '../containers/employee/employee-list/EmployeeListContainer'
import { EmployeeImportContainer } from '../containers/employee/employee-import/EmployeeImportContainer'
import { EmployeeDetailContainer } from '../containers/employee/employee-detail/EmployeeDetailContainer'
import { AddEmployeeContainer } from '../containers/employee/employee-add/AddEmployeeContainer'
import { NonEmployeeListContainer } from '../containers/non-employee/employee-list/NonEmployeeListContainer'
import { AddNonEmployeeContainer } from '../containers/non-employee/employee-add/AddNonEmployeeContainer'
import { NonEmployeeDetailContainer } from '../containers/non-employee/employee-detail/NonEmployeeDetailContainer'
import { NonEmployeeImportContainer } from '../containers/non-employee/employee-import/NonEmployeeImportContainer'
import { RegisteredNonEmployeeContainer } from '../containers/non-employee/create-contract/RegisteredNonEmployeeContainer'
import { CreateContractNonEmployeeContainer } from '../containers/non-employee/create-contract/CreateContractNonEmployeeContainer'
import { ContractNonEmployeeContainer } from '../containers/non-employee/contract-employee/ContractNonEmployeeContainer'
import { ContractNonEmployeeDetailContainer } from '../containers/non-employee/contract-employee/contract-employee-detail/ContractNonEmployeeDetailContainer'
import { ModifyContractNonEmployeeContainer } from '../containers/non-employee/contract-employee/contract-employee-detail/modify-contract/ModifyContractNonEmployeeContainer'
import { RegisteredEmployeeContainer } from '../containers/management-contract/create-contract/RegisteredEmployeeContainer'
import { CreateContractContainer } from '../containers/management-contract/create-contract/CreateContractContainer'
import { CreateContractImportContainer } from '../containers/management-contract/create-contract/create-contract-import/CreateContractImportContainer'
import { ContractEmployeeContainer } from '../containers/management-contract/contract-employee/ContractEmployeeContainer'
import { ContractEmployeeDetailContainer } from '../containers/management-contract/contract-employee/contract-employee-detail/ContractEmployeeDetailContainer'
import { GradeSettingContainer } from '../containers/organization-structure-management/grade-setting/GradeSettingContainer'
import { JobTitleSettingsContainer } from '../containers/organization-structure-management/job-title-settings/JobTitleSettingsContainer'
import { WorkUnitSettingContainer } from '../containers/organization-structure-management/work-unit-setting/WorkUnitSettingContainer'
import { OrganizationalStructureContainer } from '../containers/organization-structure-management/organizational-structure/OrganizationalStructureContainer'
import { AccountActivationContainer } from '../containers/management-account/account-activation/AccountActivationContainer'
import { RoleAccessContainer } from '../containers/management-account/role-access/RoleAccessContainer'
import { CreateRoleContainer } from '../containers/management-account/create-role/CreateRoleContainer'
import { WorkTimeContainer } from '../containers/work-settings/work-time/WorkTimeContainer'
import { WorkTimeFormContainer } from '../containers/work-settings/work-time-form/WorkTimeFormContainer'
import { DayOffListContainer } from '../containers/work-settings/day-off-list/DayOffListContainer'
import { EventContainer } from 'containers/work-settings/event/EventContainer'
import { ApprovalSettingContainer } from '../containers/matrix-approval/approval-setting/ApprovalSettingContainer'
import { ActivitySettingContainer } from '../containers/matrix-approval/activity-setting/ActivitySettingContainer'
import { PncApproverSettingContainer } from '../containers/matrix-approval/pnc-approver-setting/PncApproverSettingContainer'
import { CompanySettingsContainer } from '../containers/company-settings/CompanySettingsContainer'
import { ModifyContractContainer } from '../containers/management-contract/contract-employee/contract-employee-detail/modify-contract/ModifyContractContainer'
import { AdditionalIncentiveContainer } from '../containers/additional-incentive/AdditionalIncentiveContainer'
import { ShiftingImportContainer } from '../containers/request-shifting/shifting-import/ShiftingImportContainer'
import { ShiftingListContainer } from '../containers/request-shifting/shifting-list/ShiftingListContainer'
import { AttendanceListContainer } from '../containers/attendance/attendance-list/AttendanceListContainer'
import { ShiftingDetailContainer } from '../containers/request-shifting/shifting-detail/ShiftingDetailContainer'
import { AttendanceDetailContainer } from '../containers/attendance/attendance-list/AttendanceDetailContainer'
import { RequestLeaveContainer } from 'containers/leave-management/request-leave/RequestLeaveContainer'
import { RequestListContainer } from '../containers/attendance/request-list/RequestListContainer'
import { OvertimeContainer } from 'containers/overtime/OvertimeContainer'
import { RemoteWorkingContainer } from 'containers/remote-working/RemoteWorkingContainer'
import { LeaveSettingContainer } from 'containers/general-settings/leave-setting/LeaveSettingContainer'
import { CreateLeaveContainer } from 'containers/general-settings/leave-setting/CreateLeaveContainer'
import { RemoteWorkingSettingContainer } from 'containers/general-settings/remote-working-setting/RemoteWorkingSettingContainer'
import { GeneralOvertimeSettingContainer } from 'containers/general-settings/overtime-setting/GeneralOvertimeSettingContainer'
import { HRISAnnouncementContainer } from '../containers/general-settings/hris-announcement/HRISAnnouncementContainer'
import { HRISAnnouncementFormContainer } from '../containers/general-settings/hris-announcement-form/HRISAnnouncementFormContainer'
import { SettingComponentContainer } from '../containers/payroll/setting-component/SettingComponentContainer'
import { PayrollListContainer } from '../containers/payroll/payroll-list/PayrollListContainer'
import { IncentiveContainer } from '../containers/payroll/incentive/IncentiveContainer'
import { PercentageFormContainer } from '../containers/payroll/incentive/PercentageFormContainer'
import { PayrollDetailContainer } from '../containers/payroll/payroll-detail/PayrollDetailContainer'
import { CreatePayrollContainer } from '../containers/payroll/create-payroll/CreatePayrollContainer'
import { GeneralCreatePayrollContainer } from '../containers/payroll/create-payroll/GeneralCreatePayrollContainer'
import { SettingTypeAllowanceContainer } from '../containers/organization-structure-management/setting-type-allowance/SettingTypeAllowanceContainer'
import { AppVersionContainer } from '../containers/app-version/AppVersionContainer'
import { AnalyticsListContainer } from '../containers/attendance/analytics/AnalyticsListContainer'
import { EmployeeAnalyticsContainer } from 'containers/employee-analytics/EmployeeAnalyticsContainer'
import { LeaveAnalyticsContainer } from 'containers/leave-management/leave-analytics/LeaveAnalyticsContainer'
import { TaxPlanningSettingContainer } from 'containers/payroll/tax-planning-setting/TaxPlanningSettingContainer'
import { SopCategoryContainer } from 'containers/sop/sop-category/SopCategoryContainer'
import { SopListContainer } from 'containers/sop/sop-list/SopListContainer'
import { SopFormContainer } from 'containers/sop/sop-form/SopFormContainer'

export const ROUTE_LIST = [
    {
        path: '/employee/active-employee',
        component: <EmployeeListContainer />,
    },
    {
        path: '/employee/former-employee',
        component: <EmployeeListContainer />,
    },
    {
        path: '/employee/prospective-employee',
        component: <EmployeeListContainer />,
    },
    {
        path: '/employee/prospective-employee/import-employee',
        component: <EmployeeImportContainer />,
    },
    {
        path: '/employee/:type/detail-employee',
        component: <EmployeeDetailContainer />,
    },
    {
        path: '/employee/prospective-employee/add-employee',
        component: <AddEmployeeContainer />,
    },
    {
        path: '/non-employee-worker/non-employee-list',
        component: <NonEmployeeListContainer />,
    },
    {
        path: '/non-employee-worker/add-non-employee',
        component: <AddNonEmployeeContainer />,
    },
    {
        path: '/non-employee-worker/detail-non-employee',
        component: <NonEmployeeDetailContainer />,
    },
    {
        path: '/non-employee-worker/import-non-employee',
        component: <NonEmployeeImportContainer />,
    },
    {
        path: '/non-employee-worker/submitted-non-employee-list',
        component: <RegisteredNonEmployeeContainer />,
    },
    {
        path: '/non-employee-worker/create-non-employee-contract/:employee',
        component: <CreateContractNonEmployeeContainer />,
    },
    {
        path: '/non-employee-worker/non-employee-contract-list',
        component: <ContractNonEmployeeContainer />,
    },
    {
        path: '/non-employee-worker/non-employee-contract-detail',
        component: <ContractNonEmployeeDetailContainer />,
    },
    {
        path: '/non-employee-worker/contract-non-employee/:employee',
        component: <ModifyContractNonEmployeeContainer />,
    },
    {
        path: '/management-contract/employee-list', //Employee List
        component: <RegisteredEmployeeContainer />,
    },
    {
        path: '/management-contract/create-contract/:employee',
        component: <CreateContractContainer />,
    },
    {
        path: '/management-contract/import-contract',
        component: <CreateContractImportContainer />,
    },
    {
        path: '/management-contract/employee-contract-list',
        component: <ContractEmployeeContainer />,
    },
    {
        path: '/management-contract/contract-employee/employee-contract-detail',
        component: <ContractEmployeeDetailContainer />,
    },
    {
        path: '/management-contract/contract-employee/:employee',
        component: <ModifyContractContainer />,
    },
    {
        path: '/management-structure-organization/grade-settings',
        component: <GradeSettingContainer />,
    },
    {
        path: '/management-structure-organization/grade-settings/setting-type-allowance',
        component: <SettingTypeAllowanceContainer />,
    },
    {
        path: '/management-structure-organization/job-title-settings',
        component: <JobTitleSettingsContainer />,
    },
    {
        path: '/management-structure-organization/work-unit-settings',
        component: <WorkUnitSettingContainer />,
    },
    {
        path: '/management-structure-organization/structure-organization',
        component: <OrganizationalStructureContainer />,
    },
    {
        path: '/management-account/account-activation',
        component: <AccountActivationContainer />,
    },
    {
        path: '/management-account/role-access',
        component: <RoleAccessContainer />,
    },
    {
        path: '/management-account/role-access/create-role',
        component: <CreateRoleContainer />,
    },
    {
        path: '/management-account/role-access/update-role',
        component: <CreateRoleContainer />,
    },
    {
        path: '/management-account/account-activation/update-role-activation',
        component: <CreateRoleContainer />,
    },
    {
        path: '/work-settings/work-time',
        component: <WorkTimeContainer />,
    },
    {
        path: '/work-settings/work-time/:method',
        component: <WorkTimeFormContainer />,
    },
    {
        path: '/work-settings/day-off',
        component: <DayOffListContainer />,
    },
    {
        path: '/work-settings/event',
        component: <EventContainer />,
    },
    {
        path: '/matrix-approval/approval-setting',
        component: <ApprovalSettingContainer />,
    },
    {
        path: '/matrix-approval/activity-setting',
        component: <ActivitySettingContainer />,
    },
    {
        path: '/matrix-approval/pnc-approver-setting',
        component: <PncApproverSettingContainer />,
    },
    {
        path: '/company-settings',
        component: <CompanySettingsContainer />,
    },
    {
        path: '/additional-incentive-request',
        component: <AdditionalIncentiveContainer />,
    },
    {
        path: '/shifting',
        component: <ShiftingListContainer />,
    },
    {
        path: '/shifting/employee/detail-employee-shift',
        component: <ShiftingDetailContainer />,
    },
    {
        path: '/shifting/import-shifting',
        component: <ShiftingImportContainer />,
    },
    {
        path: '/attendance/attendance-list',
        component: <AttendanceListContainer />,
    },
    {
        path: '/attendance/attendance-list/attendance-detail',
        component: <AttendanceDetailContainer />,
    },
    {
        path: '/attendance/attendance-request-list',
        component: <RequestListContainer />,
    },
    {
        path: '/attendance/attendance-analytics',
        component: <AnalyticsListContainer />,
    },
    {
        path: '/leave-management/leave-request',
        component: <RequestLeaveContainer />,
    },
    {
        path: '/leave-management/leave-analytics',
        component: <LeaveAnalyticsContainer />,
    },
    {
        path: '/overtime-request',
        component: <OvertimeContainer />,
    },
    {
        path: '/remote-working-request',
        component: <RemoteWorkingContainer />,
    },
    {
        path: '/general-settings/leave-setting',
        component: <LeaveSettingContainer />,
    },
    {
        path: '/general-settings/leave-setting/create-leave',
        component: <CreateLeaveContainer />,
    },
    {
        path: '/general-settings/leave-setting/update-leave',
        component: <CreateLeaveContainer />,
    },
    {
        path: '/general-settings/remote-working-setting',
        component: <RemoteWorkingSettingContainer />,
    },
    {
        path: '/general-settings/overtime-setting',
        component: <GeneralOvertimeSettingContainer />,
    },
    {
        path: '/general-settings/announcement',
        component: <HRISAnnouncementContainer />,
    },
    {
        path: '/general-settings/announcement/:method',
        component: <HRISAnnouncementFormContainer />,
    },
    {
        path: '/payroll/component-setting',
        component: <SettingComponentContainer />,
    },
    {
        path: '/payroll/list-payroll',
        component: <PayrollListContainer />,
    },
    {
        path: '/payroll/list-payroll/:detail',
        component: <PayrollDetailContainer />,
    },
    {
        path: '/payroll/create-payroll',
        component: <GeneralCreatePayrollContainer />,
    },
    {
        path: '/payroll/create-payroll/:step',
        component: <CreatePayrollContainer />,
    },
    {
        path: '/payroll/incentive-setting',
        component: <IncentiveContainer />,
    },
    {
        path: '/payroll/incentive/achievement-percentage-setting',
        component: <PercentageFormContainer />,
    },
    {
        path: '/payroll/tax-planning-setting',
        component: <TaxPlanningSettingContainer />,
    },
    {
        path: '/application-version',
        component: <AppVersionContainer />,
    },
    {
        path: '/employee-analytics',
        component: <EmployeeAnalyticsContainer />,
    },
    {
        path: '/sop-settings/sop-category',
        component: <SopCategoryContainer />,
    },
    {
        path: '/sop-settings/sop-list',
        component: <SopListContainer />,
    },
    {
        path: '/sop-settings/create-sop',
        component: <SopFormContainer />,
    },
    {
        path: '/sop-settings/update-sop',
        component: <SopFormContainer />,
    },
]
